// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__30Avf","label":"SetPasswdForm_label__1xxMA"};